import { createAction } from '@reduxjs/toolkit';

export const DELETE_GREETING_ACTION_TYPE = 'saga/deleteGreeting';
export const deleteGreetingAction = createAction(DELETE_GREETING_ACTION_TYPE);
